// extracted by mini-css-extract-plugin
module.exports = {"text":"notification_message-module__text--2D0aR","border":"notification_message-module__border--1X5Go"};